import React from 'react';
import styles from './HeaderHeroImage.scss';
import { observer } from 'mobx-react-lite';
import { shouldShowThemeHeroImage } from 'mini-mail-list-view/lib/utils/mailList/shouldShowThemeHeroImage';
import { useTheme } from 'mini-theme';

export const HeaderHeroImage = observer(() => {
    const { heroImage } = useTheme();
    const showThemeHeroImage = shouldShowThemeHeroImage();
    return showThemeHeroImage ? (
        <div className={styles.container} aria-hidden>
            <img src={heroImage} className={styles.image} />
        </div>
    ) : null;
});
